<ng-container *ngTemplateOutlet="linkConfig['imageUrl'] ? image : text">
</ng-container>

<ng-template #text>
  <a [href]="linkConfig.href"
     [ngClass]="linkConfig.class"
     [ngStyle]="linkConfig.styles"
     [disabled]="disabled" #link>
     {{linkConfig.text}}<ng-content></ng-content>
  </a>
</ng-template>

<ng-template #image>
  <img alt="image button"
       [src]="linkConfig.src"
       [ngClass]="linkConfig.class"
       [ngStyle]="linkConfig.styles"
       (click)="onImgBtnClick()">
</ng-template>
